import { MetricRuleType } from '../ModelClassInterfaces/Ruleset'
import { PossibleBusinessObject } from '../types'
import { UserAttributeDefs } from '../types/ModelTypes'
import { ModelCommon } from './ModelCommon'

const debug = !process.env.AWS_SESSION_TOKEN && false
const typeName = 'MetricRule'

class MetricRule extends ModelCommon implements MetricRuleType {
  constructor(ob: PossibleBusinessObject & Partial<MetricRuleType>) {
    super(typeName, ob)

    if (ob) {
      const userAttDefs = this.getUserAttributes()
      Object.entries(userAttDefs).forEach(([key, def]) => {
        if (Object.getOwnPropertyDescriptor(def, 'default') && ob[key] === undefined) {
          this[key] = (def as { type: string; default: string }).default
        }
      })

      Object.assign(this, ob)
      debug && console.log('Tried to initialize metric rule', this)
    }
  }

  name = ''
  enabled: boolean = false
  valueType: 'bucketed' | 'latest' = 'latest'
  max = { value: null }
  min = { value: null }
  stdDev = { value: null }

  get deviceEnabledType() {
    return this._deviceEnabledType
  }

  set deviceEnabledType(type) {
    this._deviceEnabledType = type
  }

  get key() {
    return this._key
  }

  set key(metric) {
    this._key = metric
  }

  isSaveable() {
    return false
  }

  getUserAttributes(): UserAttributeDefs {
    return {
      name: { type: 'String' },
      description: { type: 'String' },
      enabled: { type: 'Boolean', default: false },
      valueType: { type: 'Enum', default: 'latest' },
      key: {
        type: 'String',
        label: 'Measurement',
      },
      max: { type: 'object', label: 'Maximum Threshold', default: { value: null } },
      min: { type: 'object', label: 'Minimum Threshold', default: { value: null } },
      stdDev: { type: 'object', label: 'Standard Deviation Threshold', default: { value: null } },
    }
  }
}

export { MetricRule }
